import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!email || !password) {
      setError('Please enter email and password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ background: '#243665', minHeight: '100vh', padding: '0' }}>
      <div style={{ 
        textAlign: 'center', 
        paddingTop: '60px', 
        paddingBottom: '40px'
      }}>
        <img 
          src="/PitchalloMOTM.png" 
          alt="Pitchallo-motm" 
          style={{ 
            maxWidth: '100%',
            width: '400px',
            marginBottom: '16px'
          }}
        />
        <p style={{ fontSize: '16px', color: '#fff' }}>
          3-2-1 Voting Made Simple
        </p>
      </div>

      <div className="card" style={{ margin: '0 20px 20px 20px' }}>
        <form onSubmit={handleLogin}>
          <div>
            <label className="input-label">EMAIL</label>
            <input
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="coach@example.com"
              autoCapitalize="none"
            />
          </div>

          <div>
            <label className="input-label">PASSWORD</label>
            <input
              type="password"
              className="input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
            />
          </div>

          {error && <p className="error">{error}</p>}

          <button 
            type="submit" 
            className="button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <button
            type="button"
            className="text-link"
            onClick={() => navigate('/signup')}
          >
            Don't have an account? Sign Up
          </button>
        </form>
      </div>

      <div style={{ 
        textAlign: 'center', 
        padding: '20px',
        color: '#fff'
      }}>
        <p style={{ marginBottom: '8px' }}>Want better club scheduling?</p>
        <a 
          href="https://pitchallo.com" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: '#FFD700', textDecoration: 'none', fontWeight: '600' }}
        >
          Check out Pitchallo →
        </a>
      </div>
    </div>
  );
}

export default Login;
